module.exports = __webpack_public_path__ + "img/cmfg2.4e2fd3b0.jpg";